import { useNavigate } from "react-router-dom";
import { zodResolver } from "@hookform/resolvers/zod";
import { FieldErrors, useForm } from "react-hook-form";

import { MessageResponseDto } from "@api/api";
import { useFormApiMapper } from "@factory/services/form-api-mapper.hook";
import { useQyCreateTenant } from "@factory/query/tenant.query";
import { TenantFormRule, TenantFormSchema } from "@factory/form/form.rule";
import { tenantFormDefault } from "@factory/form/form.default";
import { getFormErrorMessage } from "@core/utility/get-error-message";
import { useNotificationContext } from "@shared/ui/notification/notification.context";

export function useNewTenant() {
 // LOCAL DECLARATION
  const navigate = useNavigate();
  const { mapCreateTenant } = useFormApiMapper();
  const { showError, showSuccess, showWarning } = useNotificationContext();

  // QUERIES
  const handleApiSuccess = (response: MessageResponseDto) => {
    const data = response.data as any;

    showSuccess(`New Tenant is created`);
    navigate(`../${data.code}`);
  };
  const { mutate: addTenant, isLoading: isCreating } =
    useQyCreateTenant(handleApiSuccess);

  // LOCAL FUNCTIONS
  const formMethod = useForm<TenantFormSchema>({
    defaultValues: tenantFormDefault,
    resolver: zodResolver(TenantFormRule),
  });
  const { handleSubmit } = formMethod;

  const handleValidate = (form: TenantFormSchema) => {
    const formData = mapCreateTenant(form);
    addTenant(formData);
  };
  const handleValidateError = (err: FieldErrors<TenantFormSchema>) => {
    const formMessage = getFormErrorMessage(err);
    showError(formMessage);
  };

  return {
    isCreating,
    formMethod,
    navigate,
    handleSubmit,
    handleValidate,
    handleValidateError,
  };
}
